import {
  RelatorioInadimplentesItem,
  RelatorioInadimplentesFields,
} from "core/features/relatorios/typings";

export function mapItemsTotalWithSelectedFields(
  items: RelatorioInadimplentesItem[],
  selectedFields: RelatorioInadimplentesFields[]
) {
  const _items = items.map((item) => ({
    ...item,
    contas: item.contas.map((conta) => ({
      ...conta,
      total:
        (selectedFields?.includes("principal") ? conta.principal : 0) +
        (selectedFields?.includes("valorCorrecaoMonetaria")
          ? conta.valorCorrecaoMonetaria
          : 0) +
        (selectedFields?.includes("juros") ? conta.juros : 0) +
        (selectedFields?.includes("multa") ? conta.multa : 0) +
        (selectedFields?.includes("valorTaxaCobranca")
          ? conta.valorTaxaCobranca
          : 0),
    })),
    total:
      (selectedFields?.includes("principal") ? item.totalPrincipal : 0) +
      (selectedFields?.includes("valorCorrecaoMonetaria")
        ? item.totalCorrecaoMonetaria
        : 0) +
      (selectedFields?.includes("juros") ? item.totalJuros : 0) +
      (selectedFields?.includes("multa") ? item.totalMulta : 0) +
      (selectedFields?.includes("valorTaxaCobranca")
        ? item.totalTaxaCobranca
        : 0),
  }));

  return {
    items: _items,
    total: _items.reduce((acc, item) => acc + item.total, 0),
  };
}
